import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { PictureComponent } from './picture.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '../loading';
import { PlatformDisableContentModule } from '../platform-disable-content/platform-disable-content.module';
import { UserAvatarModule } from '../user-avatar/user-avatar.module';

@NgModule({
  declarations: [PictureComponent],
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    MatDialogModule,
    LoadingModule,
    TranslateModule.forChild(),
    PlatformDisableContentModule,
    UserAvatarModule,
  ],
  exports: [PictureComponent],
})
export class PictureModule {}
